var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "generic-search-list-search-bar" }, [
    _c("input", {
      staticClass: "search-input icon-search",
      attrs: { placeholder: _vm.searchPlaceholder, value: "" },
      on: {
        input: function ($event) {
          ;[_vm.triggerFilter($event), _vm.trackInput($event)]
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }